import { type AnyAction } from 'redux';
import { NOT_FOUND } from 'redux-first-router';
import { PAGES } from '../../utils/pages';

export const initialState: string | null = null;

export const page = (state: string | null = initialState, action: AnyAction): string | null => {
    if (action.type === NOT_FOUND) {
        return PAGES.NOT_FOUND;
    }
    return (PAGES as Record<string, string>)[action.type] || state;
};
